import styled from '@emotion/styled';
import { Text } from '@qga/roo-ui/components';

const NonWrappingText = styled(Text)`
  white-space: nowrap;
`;

export default NonWrappingText;
